/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "jwdeqydpxgcgkripzyvr"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp3ZGVxeWRweGdjZ2tyaXB6eXZyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDEzOTUsImV4cCI6MjA3NTkxNzM5NX0.htWq4iSzT0uDM6K24qmRJ3bmOrohtTGXx7JCwIpdXvw"